import React, { useContext, useState } from 'react';
import { X } from 'lucide-react';
import { AuthContext } from '../../context/AuthContext';
import { Alert, AlertDescription, AlertTitle } from 'components/ui/alert';
import { Button } from 'components/ui/button';

/**
 * Non-blocking migration banner for admin panel.
 * Shows a dismissible alert when user needs to migrate their subscription.
 * Password migration is now handled silently during login.
 * Unlike the web-app, this doesn't block access - just reminds.
 */
export default function MigrationBanner() {
  const { user } = useContext(AuthContext);
  const [dismissed, setDismissed] = useState(false);

  // Don't show if no user or no subscription migration needed
  // Note: Password migration is now handled silently during login
  if (!user) return null;
  if (!user.needs_subscription_migration) return null;
  if (dismissed) return null;

  // Use environment variable for storefront URL, fallback to production
  const storefrontUrl = process.env.REACT_APP_STOREFRONT_URL || 'https://draftfc.co.uk';
  const migrationUrl = `${storefrontUrl}/migrate`;

  return (
    <Alert className="rounded-none border-x-0 border-t-0">
      <div className="flex items-start justify-between gap-4">
        <div>
          <AlertTitle>Payment Update Required</AlertTitle>
          <AlertDescription>
            Please migrate your subscription to our new payment system for uninterrupted access.
          </AlertDescription>
        </div>
        <div className="flex shrink-0 items-center gap-1">
          <Button variant="outline" size="sm" asChild>
            <a href={migrationUrl} target="_blank" rel="noopener noreferrer">
              Update Payment
            </a>
          </Button>
          <Button
            variant="ghost"
            size="icon"
            aria-label="dismiss"
            onClick={() => setDismissed(true)}
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </Alert>
  );
}
